import { useContext, useMemo } from "react";
import styles from "./DesignExamples.module.scss";
import { IDesignExampleProps } from "./IDesignExamplesProps";
import { ExampleWithButtons } from "./exampleWithButtons/ExampleWithButtons";
import { AppContext } from "../../context/AppContext";
import { LimitedNeutralColorsSelector } from "../../services/LimitedNeutralColorsSelector";
import { TransformOriginHorizontal } from "./exampleWithButtons/TransformOriginHorizontal";

/**
 * A component to wrap design examples with different color combinations for a color palette
 */
export const DesignExamples: React.FC<IDesignExampleProps> = (props) => {
  const context = useContext(AppContext);
  const selectedNeutralColors = useMemo(() => {
    return new LimitedNeutralColorsSelector().select(
      context.neutralColors.value
    );
  }, [context.neutralColors]);

  //add black and white as colors to pick from
  const colors = useMemo<string[]>(
    () => [
      ...context.primaryColors.value,
      context.accentColor.value,
      ...selectedNeutralColors,
      "white",
      "black",
    ],
    [context.primaryColors, selectedNeutralColors, context.accentColor]
  );

  return (
    <div className={props.className}>
      <div className={styles.designExamples}>
        <div className={styles.designExamplesRow}>
          <ExampleWithButtons
            backgroundColor={colors[11]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[8]}
            buttonsTextColor={colors[2]}
            buttonsBackgroundColorUnselected={colors[3]}
            buttonsTextColorUnselected={colors[8]}
            primaryButtonBackgroundColor={colors[5]}
            primaryButtonTextColor={colors[2]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[11]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[8]}
            buttonsTextColor={colors[2]}
            buttonsBackgroundColorUnselected={colors[3]}
            buttonsTextColorUnselected={colors[8]}
            primaryButtonBackgroundColor={colors[5]}
            primaryButtonTextColor={colors[12]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[11]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[8]}
            buttonsTextColor={colors[12]}
            buttonsBackgroundColorUnselected={colors[9]}
            buttonsTextColorUnselected={colors[12]}
            primaryButtonBackgroundColor={colors[5]}
            primaryButtonTextColor={colors[12]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[11]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[8]}
            buttonsTextColor={colors[11]}
            buttonsBackgroundColorUnselected={colors[3]}
            buttonsTextColorUnselected={colors[8]}
            primaryButtonBackgroundColor={colors[5]}
            primaryButtonTextColor={colors[6]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[11]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[2]}
            buttonsTextColor={colors[6]}
            buttonsBackgroundColorUnselected={colors[3]}
            buttonsTextColorUnselected={colors[6]}
            primaryButtonBackgroundColor={colors[5]}
            primaryButtonTextColor={colors[6]}
            colors={colors}
            transformOriginHorizontal={TransformOriginHorizontal.RIGHT}
          />
          <ExampleWithButtons
            backgroundColor={colors[11]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[9]}
            buttonsBackgroundColor={colors[9]}
            buttonsTextColor={colors[12]}
            buttonsBackgroundColorUnselected={colors[12]}
            buttonsTextColorUnselected={colors[6]}
            primaryButtonBackgroundColor={colors[1]}
            primaryButtonTextColor={colors[6]}
            colors={colors}
            transformOriginHorizontal={TransformOriginHorizontal.RIGHT}
          />
        </div>
        <div className={styles.designExamplesRow}>
          <ExampleWithButtons
            backgroundColor={colors[11]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[8]}
            buttonsTextColor={colors[2]}
            buttonsBackgroundColorUnselected={colors[3]}
            buttonsTextColorUnselected={colors[8]}
            primaryButtonBackgroundColor={colors[6]}
            primaryButtonTextColor={colors[2]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[11]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[8]}
            buttonsTextColor={colors[2]}
            buttonsBackgroundColorUnselected={colors[3]}
            buttonsTextColorUnselected={colors[8]}
            primaryButtonBackgroundColor={colors[6]}
            primaryButtonTextColor={colors[12]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[11]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[8]}
            buttonsTextColor={colors[12]}
            buttonsBackgroundColorUnselected={colors[9]}
            buttonsTextColorUnselected={colors[12]}
            primaryButtonBackgroundColor={colors[6]}
            primaryButtonTextColor={colors[12]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[11]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[8]}
            buttonsTextColor={colors[11]}
            buttonsBackgroundColorUnselected={colors[3]}
            buttonsTextColorUnselected={colors[8]}
            primaryButtonBackgroundColor={colors[1]}
            primaryButtonTextColor={colors[6]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[11]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[2]}
            buttonsTextColor={colors[6]}
            buttonsBackgroundColorUnselected={colors[3]}
            buttonsTextColorUnselected={colors[6]}
            primaryButtonBackgroundColor={colors[1]}
            primaryButtonTextColor={colors[6]}
            colors={colors}
            transformOriginHorizontal={TransformOriginHorizontal.RIGHT}
          />
          <ExampleWithButtons
            backgroundColor={colors[11]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[9]}
            buttonsBackgroundColor={colors[9]}
            buttonsTextColor={colors[12]}
            buttonsBackgroundColorUnselected={colors[12]}
            buttonsTextColorUnselected={colors[6]}
            primaryButtonBackgroundColor={colors[1]}
            primaryButtonTextColor={colors[6]}
            colors={colors}
            transformOriginHorizontal={TransformOriginHorizontal.RIGHT}
          />
        </div>
        <div className={styles.designExamplesRow}>
          <ExampleWithButtons
            backgroundColor={colors[4]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[6]}
            buttonsTextColor={colors[11]}
            buttonsBackgroundColorUnselected={colors[11]}
            buttonsTextColorUnselected={colors[6]}
            primaryButtonBackgroundColor={colors[1]}
            primaryButtonTextColor={colors[6]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[4]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[6]}
            buttonsTextColor={colors[11]}
            buttonsBackgroundColorUnselected={colors[11]}
            buttonsTextColorUnselected={colors[6]}
            primaryButtonBackgroundColor={colors[1]}
            primaryButtonTextColor={colors[11]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[4]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[6]}
            buttonsTextColor={colors[12]}
            buttonsBackgroundColorUnselected={colors[12]}
            buttonsTextColorUnselected={colors[6]}
            primaryButtonBackgroundColor={colors[1]}
            primaryButtonTextColor={colors[12]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[4]}
            titleColor={colors[8]}
            buttonsSectionTextColor={colors[8]}
            buttonsBackgroundColor={colors[8]}
            buttonsTextColor={colors[12]}
            buttonsBackgroundColorUnselected={colors[12]}
            buttonsTextColorUnselected={colors[6]}
            primaryButtonBackgroundColor={colors[1]}
            primaryButtonTextColor={colors[12]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[4]}
            titleColor={colors[8]}
            buttonsSectionTextColor={colors[8]}
            buttonsBackgroundColor={colors[8]}
            buttonsTextColor={colors[12]}
            buttonsBackgroundColorUnselected={colors[12]}
            buttonsTextColorUnselected={colors[6]}
            primaryButtonBackgroundColor={colors[8]}
            primaryButtonTextColor={colors[12]}
            colors={colors}
            transformOriginHorizontal={TransformOriginHorizontal.RIGHT}
          />
          <ExampleWithButtons
            backgroundColor={colors[4]}
            titleColor={colors[8]}
            buttonsSectionTextColor={colors[1]}
            buttonsBackgroundColor={colors[1]}
            buttonsTextColor={colors[12]}
            buttonsBackgroundColorUnselected={colors[2]}
            buttonsTextColorUnselected={colors[6]}
            primaryButtonBackgroundColor={colors[8]}
            primaryButtonTextColor={colors[12]}
            colors={colors}
            transformOriginHorizontal={TransformOriginHorizontal.RIGHT}
          />
        </div>
        <div className={styles.designExamplesRow}>
          <ExampleWithButtons
            backgroundColor={colors[3]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[6]}
            buttonsTextColor={colors[12]}
            buttonsBackgroundColorUnselected={colors[2]}
            buttonsTextColorUnselected={colors[12]}
            primaryButtonBackgroundColor={colors[1]}
            primaryButtonTextColor={colors[6]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[3]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[1]}
            buttonsBackgroundColor={colors[1]}
            buttonsTextColor={colors[12]}
            buttonsBackgroundColorUnselected={colors[2]}
            buttonsTextColorUnselected={colors[6]}
            primaryButtonBackgroundColor={colors[6]}
            primaryButtonTextColor={colors[12]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[3]}
            titleColor={colors[2]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[6]}
            buttonsTextColor={colors[11]}
            buttonsBackgroundColorUnselected={colors[11]}
            buttonsTextColorUnselected={colors[6]}
            primaryButtonBackgroundColor={colors[1]}
            primaryButtonTextColor={colors[6]}
            headerBackgroundColor={colors[6]}
            colors={colors}
          />
        </div>
        <div className={styles.designExamplesRow}>
          {/* white background */}
          <ExampleWithButtons
            backgroundColor={colors[12]}
            titleColor={colors[9]}
            buttonsSectionTextColor={colors[9]}
            buttonsBackgroundColor={colors[9]}
            buttonsTextColor={colors[12]}
            buttonsBackgroundColorUnselected={colors[11]}
            buttonsTextColorUnselected={colors[6]}
            primaryButtonBackgroundColor={colors[1]}
            primaryButtonTextColor={colors[6]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[12]}
            titleColor={colors[6]}
            buttonsSectionTextColor={colors[6]}
            buttonsBackgroundColor={colors[6]}
            buttonsTextColor={colors[12]}
            buttonsBackgroundColorUnselected={colors[11]}
            buttonsTextColorUnselected={colors[6]}
            primaryButtonBackgroundColor={colors[1]}
            primaryButtonTextColor={colors[13]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[12]}
            titleColor={colors[1]}
            buttonsSectionTextColor={colors[1]}
            buttonsBackgroundColor={colors[1]}
            buttonsTextColor={colors[12]}
            buttonsBackgroundColorUnselected={colors[3]}
            buttonsTextColorUnselected={colors[6]}
            primaryButtonBackgroundColor={colors[6]}
            primaryButtonTextColor={colors[12]}
            colors={colors}
          />
          <ExampleWithButtons
            backgroundColor={colors[12]}
            titleColor={colors[13]}
            buttonsSectionTextColor={colors[13]}
            buttonsBackgroundColor={colors[1]}
            buttonsTextColor={colors[12]}
            buttonsBackgroundColorUnselected={colors[3]}
            buttonsTextColorUnselected={colors[13]}
            primaryButtonBackgroundColor={colors[6]}
            primaryButtonTextColor={colors[12]}
            colors={colors}
          />
        </div>
      </div>
    </div>
  );
};
